module.exports = __webpack_public_path__ + "img/icon_lifeRhythm_alert.svg";